module.exports = __webpack_public_path__ + "img/tag-icon.0b9be238.svg";